import { useEffect } from 'react';
import { useRootNavigation } from '../utils/appNavigationNames';

export default function useHideRootNavigationHeader(): void {
    const rootAppNavigation = useRootNavigation();
    useEffect(() => {
        rootAppNavigation.setOptions({
            headerShown: false,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
